import _ from 'lodash';
import * as Sentry from '@sentry/browser';

export default function(context) {
  Sentry.init({
    dsn: context.config.sentryDSN,
    whitelistUrls: ['cdn.gladly.com', 'cdn.gladly.qa'],
    environment: context.config.environment,
    ignoreErrors: ['refresh configuration error: Error: [object ProgressEvent]', 'window.ga is not a function'],
  });
  Sentry.configureScope(scope => {
    scope.setTag('cluster', context.config.cluster);
  });

  return store => {
    Sentry.addGlobalEventProcessor(event => {
      const stateBlacklist = ['messages.byId', 'user.email', 'user.name'];
      let cleanState = _.cloneDeep(store.getState());
      _.forEach(stateBlacklist, function(omitProperty) {
        cleanState = _.set(cleanState, omitProperty, '--REDACTED--');
      });

      return {
        ...event,
        extra: {
          ...event.extra,
          'redux:state': cleanState,
        },
      };
    });

    return next => action => {
      Sentry.addBreadcrumb({
        category: 'redux-action',
        message: action.type,
      });

      return next(action);
    };
  };
}
